@layer token {
  :root {
    /* BASE ----------------------------------------------------------------- */

    --n-tooltip-animation-slide-distance: 2px;
    --n-tooltip-animation-duration: 0.15s;
    --n-tooltip-animation-timing-function: ease-out;
    --n-tooltip-animation-fill-mode: forwards;
    --n-tooltip-initial-scale: 0.95;

    --n-tooltip-border-radius: var(--n-border-radius-200);
    --n-tooltip-box-shadow: var(--n-shadow-200);
  }
}

@layer component {
  /* BASE ------------------------------------------------------------------- */

  @keyframes tooltipSlideIn {
    0% {
      opacity: 0;
    }
    1% {
      opacity: 0;
      transform: scale(var(--n-tooltip-initial-scale))
        translate(var(--direction-x), var(--direction-y));
    }
    100% {
      opacity: 1;
      transform: scale(1) translate(0, 0);
    }
  }

  .tooltipEl {
    overflow: visible;
    animation-name: tooltipSlideIn;
    animation-duration: var(--n-tooltip-animation-duration);
    animation-timing-function: var(--n-tooltip-animation-timing-function);
    animation-fill-mode: var(--n-tooltip-animation-fill-mode);
    opacity: 0;
    transform: scale(1) translate(0, 0);
    position: absolute;

    &[data-placement='top'] {
      --direction-x: 0;
      --direction-y: var(--n-tooltip-animation-slide-distance);
      &[data-has-arrow='true'] {
        padding-bottom: var(--n-floating-content-arrow-base-to-tip-length);
      }
    }

    &[data-placement='top'][data-align='start'] {
      transform-origin: left center;
    }
    &[data-placement='top'][data-align='center'] {
      transform-origin: bottom center;
    }
    &[data-placement='top'][data-align='end'] {
      transform-origin: right center;
    }

    &[data-placement='left'] {
      --direction-x: var(--n-tooltip-animation-slide-distance);
      --direction-y: 0;
      &[data-has-arrow='true'] {
        padding-right: var(--n-floating-content-arrow-base-to-tip-length);
      }
    }

    &[data-placement='left'][data-align='start'] {
      transform-origin: right top;
    }
    &[data-placement='left'][data-align='center'] {
      transform-origin: right center;
    }
    &[data-placement='left'][data-align='end'] {
      transform-origin: right bottom;
    }

    &[data-placement='bottom'] {
      --direction-x: 0;
      --direction-y: calc(var(--n-tooltip-animation-slide-distance) * -1);
      transform-origin: top center;
      &[data-has-arrow='true'] {
        padding-top: var(--n-floating-content-arrow-base-to-tip-length);
      }
    }

    &[data-placement='bottom'][data-align='start'] {
      transform-origin: left center;
    }
    &[data-placement='bottom'][data-align='center'] {
      transform-origin: top center;
    }
    &[data-placement='bottom'][data-align='end'] {
      transform-origin: right center;
    }

    &[data-placement='right'] {
      --direction-x: calc(var(--n-tooltip-animation-slide-distance) * -1);
      --direction-y: 0;
      &[data-has-arrow='true'] {
        padding-left: var(--n-floating-content-arrow-base-to-tip-length);
      }
    }

    &[data-placement='right'][data-align='start'] {
      transform-origin: left top;
    }
    &[data-placement='right'][data-align='center'] {
      transform-origin: left center;
    }
    &[data-placement='right'][data-align='end'] {
      transform-origin: left bottom;
    }
  }

  .tooltip {
    position: relative;
    display: flex;
    border-radius: var(--n-tooltip-border-radius);
    box-shadow: var(--n-tooltip-box-shadow);
  }
}
